// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lQvh2","delete":"styles_delete__ULZEn","update":"styles_update__KBhG5","add":"styles_add__z7wuT"};